import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
  ViewEncapsulation,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { MenuItem } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

import { DashboardServiceService } from '@admin/shared/services/dashboard-service.service';

import { CreateWorkspaceDialogComponent } from '@common/popups/create-workspace-dialog/create-workspace-dialog.component';

import { UserProfileService } from '@core/services/user.service';
import { AuthenticationService } from '@core/services/auth.service';

import { environment } from '@environment/environment';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrl: './top-bar.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class TopBarComponent implements OnInit, OnDestroy {
  @ViewChild('header') header!: ElementRef;

  preventAbuse = false;
  workspaces: any[] | undefined = [];
  userData: any;
  selectedWorkspace: any;

  items: MenuItem[] | undefined;
  progressBarTop: string = '';
  sideChat = false;
  activeWorkspace: any;

  // Changelog unread indicator
  hasUnreadChangelog = false;
  private subscription = new Subscription();
  helpMenuItems = [
    {
      label: 'Help Center',
      icon: 'pi pi-question-circle',
      command: () => {
        window.open('https://support.confe.io', '_blank');
      },
    },
    {
      label: 'Product Tour',
      icon: 'pi pi-play-circle',
      command: () => {
        if (window.Produktly) {
          window.Produktly.startTour({
            tourId: 7926,
          });
        }
      },
    },
    {
      label: 'Create Post Guide',
      icon: 'pi pi-file-edit',
      command: () => {
        if (window.Produktly) {
          window.Produktly.startTour({
            tourId: 5393,
          });
        }
      },
    },
    {
      label: 'Report Bug',
      icon: 'pi pi-exclamation-triangle',
      command: () => {
        if (!window.Produktly) {
          window.Produktly = {};
        }
        window.Produktly.openFeedback({ id: 1280 });
      },
    },
  ];
  constructor(
    private userProfileService: UserProfileService,
    private dashboardService: DashboardServiceService,
    private authService: AuthenticationService,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {
    this.userData = {
      name: '',
    };
    this.getActiveWorkspace();
  }

  getActiveWorkspace() {
    this.dashboardService
      .getWorkspace()
      .subscribe((workspace) => (this.activeWorkspace = workspace));
  }
  ngOnInit() {
    this.userProfileService.getUser().subscribe({
      next: (res) => {
        if (res) {
          // set workspace when no route is there because only route set workspace
          const currentWorkspace = res.workspaces.find(
            (workspace: { uuid: any }) => workspace.uuid === res.settings.active_workspace
          );
          if (currentWorkspace) {
            // Set the workspace in the dashboard service
            this.dashboardService.setWorkspace(currentWorkspace);
          }
          //  this.dashboardService.setWorkspace(res.settings.active_workspace);
          this.workspaces = res.workspaces;
          this.userData = res.user;
        }
      },
    });

    this.dashboardService.getWorkspace().subscribe({
      next: (res) => {
        this.selectedWorkspace = res;
        this.cdr.detectChanges();
      },
    });
    this.checkChangelogUnreadCount();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  changeWorkspace(event: any) {
    this.preventAbuse = true;

    this.dashboardService.switchWorkspace(event.value.uuid).subscribe({
      next: () => {
        this.dashboardService.setWorkspace(event.value);
        this.preventAbuse = false;
        this.router.navigate(['/']);
      },
      error: () => {
        this.preventAbuse = false;
      },
    });
  }

  /**
   * check for paid subscription
   */
  isPaidSubscriptionActive(): boolean {
    if (this.selectedWorkspace.planInfo.subscriptionInfo?.subscription?.status !== 'active')
      return false;

    const endDate = this.selectedWorkspace.planInfo.subscriptionInfo?.subscription?.renews_at;
    if (!endDate) return false;
    return new Date(endDate).toISOString() > new Date().toISOString();
  }

  logout() {
    this.authService.signOut();
  }

  createNewWorkspace() {
    this.dialogService.open(CreateWorkspaceDialogComponent, {
      breakpoints: { '1199px': '75vw', '575px': '90vw' },
    });
  }

  private checkChangelogUnreadCount() {
    if (environment.production && window.Produktly && window.Produktly.getChangelogUnreadCount) {
      window.Produktly.getChangelogUnreadCount({ id: 579 })
        .then((unreadCount: number) => {
          this.hasUnreadChangelog = unreadCount > 0;
          this.cdr.detectChanges();
        })
        .catch((error: any) => {
          console.warn('Failed to get changelog unread count:', error);
          this.hasUnreadChangelog = false;
          this.cdr.detectChanges();
        });
    } else {
      // Fallback: show dot in production if API is not available
      this.hasUnreadChangelog = environment.production;
      this.cdr.detectChanges();
    }
  }

  openChangeLog() {
    if (environment.production) {
      if (!window.Produktly) {
        window.Produktly = {};
      }
      window.Produktly.openChangelog({ id: 579 });
    }
  }
}
